import { useMutation } from '@tanstack/react-query';

import type { CompanyFormResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCompanyFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: FormData;
    }) =>
      HttpClient.request<CompanyFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
  });
